import { Prices } from '@bytel/bytel-sales';

import { Odr, OdrRsf } from '@app/catalog/products/interface/phone';
import { Scheme } from '@app/checkout/cart/scheme.class';

export interface Renew {
    type?: 'collaborator' | 'client';
    obligation?: 'month12' | 'month18' | 'month24';
}

export interface EdpData {
    price?: number;
    amount?: number;
    duration?: number;
}

export interface WallPrice {
    price?: number;
    type?: string;
    amount?: number;
}

export interface ObjectOfType<interfaceType> {
    [index: string]: interfaceType;
}

export interface ArrayStringIndex {
    [index: string]: ArrayStringIndex;
}

export interface Array2StringIndex {
    [index: string]: ArrayStringIndex;
}

export interface JsonCatalog {
    [index: string]: JsonProduct;
}

export interface RenewPrice {
    client: PriceClientType;
    collaborator: PriceClientType;
}

export interface PriceClientType {
    [index: string]: MinPrice;
}

export interface ProductPriceByPlan {
    base_price: number;
    price: number;
    plan_name?: string;
    plan_data?: string;
    odr_rsf?: OdrRsf;
}
export interface ProductPrice {
    min: ArrayStringIndex;
    plans: ObjectOfType<{ renew: RenewPrice; acquisition: MinPrice }>;
    gencode?: string;
    premium?: ProductPriceByPlan;
    sowo?: ProductPriceByPlan;
}

export interface JsonProduct {
    product_ids?: string[];
    product_gencode?: string[];
    gencode?: string;
    name: string;
    type_id: string;
    price?: number;
    sku: string;
    entity_id?: number;
    can_migrate?: boolean;
    edp?: EdpData;
    edp_price?: string;
    final_price?: string;
    prices?: ProductPrice;
    manufacturer?: string;
    categories?: string[];
    [index: string]: any;
    color_code?: string;
    position?: number;
    charging_head?: boolean;
    max_load_power?: string;
    min_load_power?: string;
    good_deals?: number;
    selling_date?: Date;
    sar?: number;
    obligation_label?: string;
    locked?: any;
    low_prices_wall?: boolean;
    odr?: Odr;
    essential?: boolean;
}

export interface MinPrice {
    price?: number;
    edp_price?: number;
    edp?: boolean;
}

export interface Filter {
    category?: string;
    type_id?: string[];
}

export interface Filters {
    [index: string]: string[];
}

export interface PhonePlanPrice {
    plan: string;
    price: number;
    edp: EdpData;
}

interface JsonCategoryActions {
    detailCategory: {
        href: string;
        method: string;
    };
}

export interface JsonCategory {
    id: string;
    name: string;
    description: string;
    code: string;
    _actions: JsonCategoryActions;
    children: JsonCategory[];
    products?: JsonProduct[];
}

export interface PlanJsonCategories {
    categories: PlanJsonCategory[];
}

export interface PlanJsonCategory {
    children: string[];
    code: string;
    description: string;
    id: string;
    image: string;
    image_mobile: string;
    meta_description: string;
    meta_keywords: string;
    meta_title: string;
    name: string;
    products: JsonProduct[];
    slider_position: number;
    subtitle: string;
    url: string;
    _links: { [key: string]: any };
    anim_co: string;
}

export interface RenewPlansParams {
    phone_sku: string;
    owned_plan_sku: string;
    month: string;
    device_seniority: number;
    client_type: string;
}
export interface ApiPromos {
    type: string;
    reduction: number;
    estIncitation?: boolean;
    typesAcces: string[];
    valeur: number;
    duree?: number;
    proprietesSupplementaires: ProprietesSupplementaires;
}
export interface ApiFunding {
    type: string;
    apportInitial: number;
    nbrEcheances: number;
    montantMensualite: number;
    montantInteret: number;
    tAEG: number;
    tauxDebiteurFixe: number;
    prefere: boolean;
    label?: string;
    apportInitialOdr?: number;
    apportInitialHT?: number;
    apportInitialOdrHT?: number;
}

export interface ApiContextualiseResponse {
    initiateur?: string;
    nombreTotalProduits: number;
    produits: ApiProduct[];
}
export interface ApiProduct {
    nom?: string;
    description?: string;
    marque?: string;
    gencode?: string;
    image?: string;
    couleurs?: [];
    etiquetteAnimCo?: string;
    note?: number;
    connectivite?: string;
    dispoCnc?: boolean;
    url: string;
    promotions: Promotion[];
    prix: PriceProduitsSapic;
    financements: ApiFunding[];
    priceFrom: boolean;
    panierSimule?: PanierSimule;
    recommande: boolean;
    type: string;
    libelleEnveloppeData?: string;
    libelleEnveloppeVoix?: string;
}

export interface PriceProduitsSapic {
    initial: number;
    subventionne: number;
    pourToujours: number;
    final: number;
}

export interface ShippingDataModel {
    wording: string;
    isFreeShipping: boolean;
}

export interface ProprietesSupplementaires {
    fanion?: string;
    typesMarketing: string[];
}

export interface Promotion {
    id: string;
    valeur: number;
    reduction: number;
    type: string;
    typesAcces: string[];
    estIncitation: boolean;
    proprietesSupplementaires: ProprietesSupplementaires;
    duree: number;
}

export interface ApiPrices {
    forever: number;
    final: number;
    initial: number;
    grant?: number;
    duration?: number;
}

export interface SchemeAndPrices {
    scheme: Scheme;
    prices: CurrentPrices;
}

export interface PromosByProduct {
    plan: number;
    phone: number;
}
export interface PricesByProduct {
    plan: Prices;
    phone: Prices;
}

export interface CurrentPrices {
    planPrices: Prices;
    selectedFunding: ApiFunding;
    instantDiscount: number;
    odr: number;
    salesPercent: number;
}

export interface Parcours {
    estCourant: boolean;
    promotions: any[];
    produits: ApiProduct[];
}

export interface PanierSimule {
    promotions: any[];
    financements: Financement[];
    parcours: Parcours[];
}

export interface Financement {
    type: string;
    prefere: boolean;
    apportInitial: number;
    nbrEcheances: number;
    montantMensualite: number;
    tAEG: number;
    montantInteret: number;
    coutTotalFinancement: number;
    montantAFinancer: number;
}

export interface ApiProductContainers {
    [index: number]: ApiProduct;
}

export enum TypesMarketing {
    SOLDES = 'SOLDES',
}

export enum CommercialRange {
    BYOU = 'b_you',
    PREMIUM = 'forfait_avec_mobile',
    FSM = 'forfait_sans_mobile',
}

export enum PlanGammeLabel {
    BYOU = 'B&You',
    PROMPTO = 'Prompto',
}
